/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFlujosEtapas from 'Infotrack@Modelos/smartStock/flujosEtapas';
import IFlujosEtapas from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapas';

export default class ControladorModeloFlujosEtapas {
    private modeloFlujosEtapas: ModeloFlujosEtapas;
    constructor() {
        this.modeloFlujosEtapas = new ModeloFlujosEtapas();
    }

    public async consultarFlujosEtapas(EmpresaId: string) {
        const {
            data: { Entidades },
        } = await this.modeloFlujosEtapas.consultaFlujosEtapasCompuestaPorFiltro({ EmpresaId });
        return Entidades;
    }

    public async crearFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        return this.modeloFlujosEtapas.crearFlujosEtapas(flujosEtapas);
    }

    public async editarFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        return this.modeloFlujosEtapas.editarFlujosEtapas(flujosEtapas);
    }

    public async eliminarFlujosEtapas(flujosEtapas: IFlujosEtapas) {
        await this.modeloFlujosEtapas.eliminarFlujosEtapas(flujosEtapas);
    }

    public validarEntidad(flujosEtapas: IFlujosEtapas): boolean {
        if (
            !flujosEtapas.EmpresaId ||
            !flujosEtapas.FlujoId ||
            !flujosEtapas.EtapaActual ||
            !flujosEtapas.EtapaSiguiente
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
